import api from './api';

const videoService = {
    // Get upload signed URL
    getUploadUrl: async (awb, scanType, filename, fileSize) => {
        const response = await api.post('/api/videos/upload-url', {
            awb,
            scanType,
            filename,
            fileSize
        });
        return response.data;
    },

    // Get user's videos
    getVideos: async (params = {}) => {
        const response = await api.get('/api/videos', { params });
        return response.data;
    },

    // Get all videos (admin only)
    getAllVideos: async (params = {}) => {
        const response = await api.get('/api/videos/all', { params });
        return response.data;
    },

    // Get failed videos (admin only)
    getFailedVideos: async (params = {}) => {
        const response = await api.get('/api/videos/failed', { params });
        return response.data;
    },

    // Get playback URL. `action` (view | download | copy_link) records why the
    // video was accessed, for the evidence access log.
    getPlaybackUrl: async (videoId, { download = false, action } = {}) => {
        const params = {};
        if (download) params.download = true;
        if (action) params.action = action;
        const response = await api.get(`/api/videos/${videoId}/playback-url`, { params });
        return response.data;
    },

    // Get access history (who viewed/downloaded/copied this video, and when) — admin only
    getAccessLog: async (videoId) => {
        const response = await api.get(`/api/videos/${videoId}/access-log`);
        return response.data;
    },

    // Update customer escalation / audit annotations
    updateAnnotations: async (videoId, data) => {
        const response = await api.patch(`/api/videos/${videoId}/annotations`, data);
        return response.data;
    },

    // Export videos to CSV
    exportVideos: async (params = {}) => {
        const response = await api.get('/api/videos/export', {
            params,
            responseType: 'blob'
        });
        return response.data;
    }
};

export default videoService;
